<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.717 19.721" height="1em">
    <path fill="currentColor"
      d="M23.985,22.787,18.5,17.252a7.815,7.815,0,1,0-1.186,1.2l5.448,5.5a.844.844,0,0,0,1.191.031A.849.849,0,0,0,23.985,22.787ZM12.361,18.52a6.171,6.171,0,1,1,4.364-1.807A6.133,6.133,0,0,1,12.361,18.52Z"
      transform="translate(-4.5 -4.493)" />
  </svg>
</template>
